import { render } from "./PayInoiceView.vue?vue&type=template&id=21edff7f&ts=true"
import script from "./PayInoiceView.vue?vue&type=script&lang=ts"
export * from "./PayInoiceView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__